import { QuoteService } from 'quote-domain-core';

export abstract class AbstractPriceEngineCalculator {
    constructor(protected quoteService: QuoteService, protected referential: any, protected referentialService: any, protected region: any) {}
    abstract execute(): void;
}
